import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import { isMobile, isChrome } from "react-device-detect";
import useMediaQuery from "@mui/material/useMediaQuery";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import srtParser2 from "srt-parser-2";
import { default as toWebVTT } from "srt-webvtt";
import FirstLoginDialog from "./FirstLoginDialog";

export default function MediaCard({ handleFullScreen, handlePlayingStatus }) {
  const { videoInfo, handleVideoInfo, handleSubtitleContenet } =
    useContext(MainContext);
  const [opacityIndex, setOpacityIndex] = React.useState(1000);
  const [typeVideoAlert, setTypeVideoAlert] = React.useState(true);
  const detectSize700px = useMediaQuery("(min-width:700px)");
  const allVideos = [
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/00.png`,
      imgTitle: "0-آشنایی با برنامه",
      videoTitle: "0-آشنایی با برنامه",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialmobile.mp4`
            : `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialpc.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
        setTimeout(() => {
          addTrackToVideo();
        }, 2000);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/video/img/100.png`,
      imgTitle: "نمیدونم چطور با برنامه کار کنم؟",
      videoTitle: "نمیدونم چطور با برنامه کار کنم؟",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: `${process.env.REACT_APP_SITEURL}/video/tutorial/0-main.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/video/img/101.png`,
      imgTitle: "شروع کاربا سایت",
      videoTitle: "1- شروع کاربا سایت",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: `${process.env.REACT_APP_SITEURL}/video/newVideo/101.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/video/img/102.png`,
      imgTitle: "1-1- دریافت فیلم و سریال",
      videoTitle: "1-1- دریافت فیلم و سریال",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: `${process.env.REACT_APP_SITEURL}/video/newVideo/102.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/02.png`,
      imgTitle: "دانلود رایگان فیلم و سریال",
      videoTitle: "2- دانلود رایگان فیلم و سریال",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/doawnloadMovies.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/doawnloadMovies.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box2.png`,
      imgTitle: "انتخاب زیرنویس هماهنگ با فیلم",
      videoTitle: "3- انتخاب زیرنویس هماهنگ",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/01-box2.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/01-box2.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box4.png`,
      imgTitle: "مشاهده ترجمه لغات",
      videoTitle: "4- مشاهده ترجمه لغات",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/04-box4.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/04-box4.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box5.png`,
      imgTitle: "ذخیره لغات و اصطلاحات",
      videoTitle: "4- ذخیره لغات و اصطلاحات",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/05-box5.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/05-box5.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box6.png`,
      imgTitle: "کار با لایتنر",
      videoTitle: "5- کار با لایتنر",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/06-box6.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/06-box6.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box7.png`,
      imgTitle: "مرور لغات و تماشای فیلم",
      videoTitle: "6- مرور لغات و تماشای فیلم",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/07-box7.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/07-box7.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box8.png`,
      imgTitle: "سطح بندی لغات فیلم",
      videoTitle: "7- سطح بندی لغات فیلم",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/08-box8.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/08-box8.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box9.png`,
      imgTitle: "کنترل استایل و موقعیت زیرنویس",
      videoTitle: "8- کنترل استایل و موقعیت زیرنویس",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/09-box9.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/09-box9.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box3.png`,
      imgTitle: "هماهنگ سازی دو زیرنویس",
      videoTitle: "9- هماهنگ سازی زیرنویس",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/03-box3.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/03-box3.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    {
      imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box10.png`,
      imgTitle: "دانلود رایگان سریال فرندز",
      videoTitle: "10- دانلود رایگان سریال فرندز",
      videoDescription: "",
      clickAction: () => {
        handleVideoInfo({
          ...videoInfo,
          videoFile: isMobile
            ? `${process.env.REACT_APP_SITEURL}/videoBox/10-box10.mp4`
            : `${process.env.REACT_APP_SITEURL}/videoBox/10-box10.mp4`,
        });
        handleFullScreen.enter();
        handlePlayingStatus(true);
      },
    },
    // {
    //     imgsrc: `${process.env.REACT_APP_SITEURL}/videoBox/box11.png`, imgTitle: "حل مشکل ناخوانا بودن زیرنویس", videoTitle: "حل مشکل ناخوانا بودن زیرنویس", videoDescription: "",
    //     clickAction: () => {
    //         handleVideoInfo({
    //             ...videoInfo,
    //             videoFile: isMobile ? `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialmobile.mp4` : `${process.env.REACT_APP_SITEURL}/videoBox/.mp4.mp4`,
    //         });
    //         handleFullScreen.enter();
    //         handlePlayingStatus(true)
    //     }
  ];

  const handleClickPlayVideo = () => {
    handleVideoInfo({
      ...videoInfo,
      videoFile: isMobile
        ? `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialmobile.mp4`
        : `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialpc.mp4`,
    });
    handleFullScreen.enter();
    handlePlayingStatus(true);
    setTimeout(() => {
      addTrackToVideo();
    }, 2000);
  };

  const subtitleOneControl = (subtitileOneJson, langOne) => {
    handleSubtitleContenet("One", "");
    if (subtitileOneJson.length == 0) return false;
    let trackOne = document.querySelector("#subtitlesOneTrack");
    trackOne.addEventListener("cuechange", function (e) {
      if (e.target.track.activeCues.length !== 0) {
        handleSubtitleContenet(
          "One",
          subtitileOneJson[e.target.track.activeCues[0].id - 1].text
        );
      } else {
        handleSubtitleContenet("One", "");
      }
    });
  };

  const subtitleTwoControl = (subtitileTwoJson, langTwo) => {
    handleSubtitleContenet("Two", "");
    if (subtitileTwoJson.length == 0) return false;
    let trackTwo = document.querySelector("#subtitlesTwoTrack");
    trackTwo.addEventListener("cuechange", function (e) {
      if (e.target.track.activeCues.length !== 0) {
        handleSubtitleContenet(
          "Two",
          subtitileTwoJson[e.target.track.activeCues[0].id - 1].text
        );
      } else {
        handleSubtitleContenet("Two", "");
      }
    });
  };

  const srtToJson = (file, lang, number) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const text = reader.result;
      let parser = new srtParser2();
      let result = parser.fromSrt(text);
      if (number == "one") subtitleOneControl(result, lang);
      if (number == "two") subtitleTwoControl(result, lang);
    };
  };

  const addTrackToVideo = async () => {
    try {
      let video = document.querySelector("#MainVideo video");
      let response1;
      await fetch(
        isMobile
          ? `${process.env.REACT_APP_SITEURL}/videoBox/sub1-1-mob.srt`
          : `${process.env.REACT_APP_SITEURL}/videoBox/sub1-1-pc.srt`
      )
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          response1 = blob;
        });
      let subFile1 = new File([response1], "subone.srt");
      const textTrackUrl1 = await toWebVTT(subFile1);
      let oldTrack1 = document.getElementById("subtitlesOneTrack");
      if (oldTrack1) video.removeChild(oldTrack1);
      let track1 = document.createElement("track");
      track1.kind = "subtitles";
      track1.id = "subtitlesOneTrack";
      track1.src = textTrackUrl1;
      track1.srclang = "en";
      video.appendChild(track1);
      srtToJson(subFile1, "en", "one");

      let response2;
      await fetch(
        isMobile
          ? `${process.env.REACT_APP_SITEURL}/videoBox/sub1-2-mob.srt`
          : `${process.env.REACT_APP_SITEURL}/videoBox/sub1-2-pc.srt`
      )
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          response2 = blob;
        });
      let subFile2 = new File([response2], "subone.srt");
      const textTrackUrl2 = await toWebVTT(subFile2);
      let oldTrack2 = document.getElementById("subtitlesTwoTrack");
      if (oldTrack2) video.removeChild(oldTrack2);
      let track2 = document.createElement("track");
      track2.kind = "subtitles";
      track2.id = "subtitlesTwoTrack";
      track2.src = textTrackUrl2;
      track2.srclang = "fa";
      video.appendChild(track2);
      srtToJson(subFile2, "fa", "two");

      if (video["textTracks"]) {
        for (let i = 0; i < video["textTracks"].length; i++) {
          video.textTracks[i].mode = "hidden";
        }
      }
    } catch (error) {
      console.log("Error in addTrackToVideo", error);
    }
  };

  return (
    <>
      {/* <FirstLoginDialog handleClickPlayVideo={handleClickPlayVideo} />
            <Alert sx={{ mx: detectSize700px ? 15 : 0, px: 5, display: videoInfo.videoFile && typeVideoAlert ? null : "none" }} severity="error" onClose={() => { setTypeVideoAlert(false) }}>
                <a target='_blank' href='https://forum.umlang.com/topic/42/%D9%85%D8%B4%DA%A9%D9%84-%D9%BE%D8%AE%D8%B4-%D9%81%DB%8C%D9%84%D9%85-%D8%A8%D8%AF%D9%88%D9%86-%D8%AA%D8%B5%D9%88%DB%8C%D8%B1-%D9%81%D9%82%D8%B7-%D8%B5%D8%AF%D8%A7'>اگر مشکلی در نمایش فیلم وجود دارد اینجا کلیک کنید</a>
            </Alert>
            <Typography
            onClick={() => {window.open('https://umlang.com/app/', '_blank');}}
             sx={{  fontWeight: "bold",fontSize:35 }}>
                اپلیکیشن موبایل برنامه منتشر شد
              </Typography>
              <Button
                variant="contained"
                color="success"
                sx={{ px: 6,fontSize:25 }}
                onClick={() => {
                    window.open('https://umlang.com/app/', '_blank');
                }}
              >
                مشاهده اپ موبایل
              </Button> */}
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          flexWrap: "wrap",
          mx: 10,
          mt: 0,
        }}
      >
        {/* <Card sx={{ width: 200, m: 1, position: "relative" }}>
          <CardMedia
            sx={{ height: 160, m: 0 }}
            image={`${process.env.REACT_APP_SITEURL}/videoBox/00.png`}
            title="آشنایی با سایت"
          />
          <CardContent sx={{ pt: 1 }}>
            <Typography
              gutterBottom
              sx={{ m: 0, fontWeight: "bold" }}
              component="div"
            >
              {"آشنایی با سایت"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {""}
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: "center" }}>
            <Button
              variant="contained"
              sx={{ px: 6, position: "absolute", bottom: "3px" }}
              onClick={() => {
                handleVideoInfo({
                  ...videoInfo,
                  videoFile: isMobile
                    ? `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialmobile.mp4`
                    : `${process.env.REACT_APP_SITEURL}/video/tutorial/maintutorialpc.mp4`,
                });
                handleFullScreen.enter();
                handlePlayingStatus(true);
                setTimeout(() => {
                  addTrackToVideo();
                }, 2000);
              }}
              size="small"
            >
              مشاهده
            </Button>
          </CardActions>
        </Card> */}
      </Box>
      {/* {isChrome ? null : (
        <Paper sx={{ mx: 12 }}>
          <Typography>لطفا از مرورگر Chrome استفاده کنید</Typography>
          <Typography>
            مرورگر Chrome پشتبانی بیشتری از انواع ویدئو ها دارد
          </Typography>
        </Paper>
      )} */}
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          flexWrap: "wrap",
          mx: "auto",
          mt: 0,
          // maxWidth: "1000px",
        }}
      >
        {allVideos.map((video, index) => (
          <Card
            id={`ssss-${index}`}
            key={`startVideo-${index}`}
            sx={{
              width: 200,
              m: 1,
              position: "relative",
              boxShadow:
                opacityIndex == index
                  ? "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                  : null,
            }}
            onMouseEnter={() => {
              setOpacityIndex(index);
            }}
            onMouseLeave={() => {
              setOpacityIndex(1000);
            }}
          >
            <CardMedia
              sx={{
                height: 160,
                m: 0,
                opacity: opacityIndex == index ? 1 : 0.5,
              }}
              image={video.imgsrc}
              title="green iguana"
            />
            <CardContent sx={{ pt: 1 }}>
              <Typography
                gutterBottom
                sx={{ m: 0, fontWeight: "bold" }}
                component="div"
              >
                {video.videoTitle}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {video.videoDescription}
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{ px: 6, position: "absolute", bottom: "3px" }}
                onClick={(e) => {
                  video.clickAction();
                  e.target.blur();
                }}
                size="small"
              >
                مشاهده
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
    </>
  );
}
